import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddAccessLevelApi, AddAccessLevelTwoApi, JobsGroupApi, GetAccessItemApi } from "../../../api";
import { Link, useNavigate } from "react-router-dom";

export const AccessLevelAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [listGroupJob, setListGroupJob] = useState<any>([])
    const [listGroupJobKeeper, setListGroupJobKeeper] = useState([])
    const [listAccessListItem, setListAccessListItem] = useState([])
    const [listAccessListItemKeeper, setListAccessListItemKeeper] = useState([])
    const [selectedAccess, setSelectedAccess] = useState<any>([])
    const [selectedGroupJob, setSelectedGroupJob] = useState<any>([])

    const handelSearchGroupJob = (value: any) => {
        setListGroupJob(
            listGroupJobKeeper.filter((value1: any) => {
                return !!(value1.name.toUpperCase().includes(value.toUpperCase()));
            })
        )
    }

    const handelSearchAccess = (value: any) => {
        setListAccessListItem(
            listAccessListItemKeeper.filter((value1: any) => {
                return !!(value1.title.toUpperCase().includes(value.toUpperCase()));
            })
        )
    }

    const onFinishAddStepTwo = async (id: any) => {
        let res = await AddAccessLevelTwoApi(id, selectedAccess)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.status) {
            toast("با موفقیت ثبت گردید", { type: "success" })
            navigate('/p/settings/access-level');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const onFinishAddStepOne = async (e: any) => {
        e.preventDefault()
        if (selectedAccess.length == 0) return toast('انتخاب حداقل یک سطح الزامی میباشد', { type: "error" })
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await AddAccessLevelApi(formRef, selectedGroupJob)
        if (res.status) {
            onFinishAddStepTwo(res.group.id)
        }
        else {
            toast(res.message, { type: "error" })
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    const getAccessListItem = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await GetAccessItemApi()
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.status) {
            setListAccessListItem(res.data.accesses)
            setListAccessListItemKeeper(res.data.accesses)
        }
    }

    const getGroupJobData = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await JobsGroupApi()
        if (res.success) {
            setListGroupJob(res.data)
            setListGroupJobKeeper(res.data)
        }
    }


    useEffect(() => {
        document.title = "افزودن سطح دسترسی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 5, })
        getGroupJobData()
        getAccessListItem()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">افزودن سطح دسترسی</h1>

            <form ref={formRef} onSubmit={onFinishAddStepOne} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CInputText name="name" title="نام سطح" type="text" required={true} />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="w-full flex flex-col mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className="w-full lg:flex-row flex-col flex justify-between lg:items-center items-start">
                        <div className="flex flex-col">
                            <span className="">انتخاب گروه شغلی </span>
                            <span className="text-[12px] mt-2">این گزینه اختیاری بوده و می توانید یک یا چند گروه شغلی انتخاب نمایید تا سطوح دسترسی فقط برای آن گروه ها فعال شود</span>
                        </div>
                        <div className="w-[200px] lg:mt-0 mt-4" >
                            <input onChange={(e: any) => handelSearchGroupJob(e.target.value)} type="text" placeholder="جستجو گروه شغلی" className="w-full h-[40px] border rounded px-2 text-[11px] focus:outline-none" />
                        </div>
                    </div>
                    <div className=" w-full flex flex-wrap items-center mt-4">
                    <AccessLevelSelectAll allItems={listGroupJob} listSelected={selectedGroupJob} setListSelected={setSelectedGroupJob} />
                        {listGroupJob.map((item: any, index: any) =>
                            <AccessLevelAddItem key={index} name={'name'} item={item} listSelected={selectedGroupJob} setListSelected={setSelectedGroupJob} />
                        )}
                    </div>
                </div>

                <div className="w-full flex flex-col mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className="w-full lg:flex-row flex-col flex justify-between lg:items-center items-start">
                        <div className="flex flex-col">
                            <span className="">انتخاب سطح </span>
                            <span className="text-[12px] mt-2"> بخش هایی که مایل هستید تا این سطح از کاربری به آن دسترسی داشته باشد را انتخاب نمایید</span>
                        </div>
                        <div className="w-[200px] lg:mt-0 mt-4" >
                            <input onChange={(e: any) => handelSearchAccess(e.target.value)} type="text" placeholder="جستجو سطح دسترسی" className="w-full h-[40px] border rounded px-2 text-[11px] focus:outline-none" />
                        </div>
                    </div>
                    <div className=" w-full flex flex-wrap items-center mt-4">
                        <AccessLevelSelectAll allItems={listAccessListItem} listSelected={selectedAccess} setListSelected={setSelectedAccess} />
                        {listAccessListItem.map((item: any, index: any) =>
                            <AccessLevelAddItem key={index} name={'title'} item={item} listSelected={selectedAccess} setListSelected={setSelectedAccess} />
                        )}
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/access-level'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}



export const AccessLevelAddItem = ({ listSelected, setListSelected, item, name }: InputProps) => {

    const handelCheckItem = (id: string) => {
        let data = [...listSelected];
        if (data.indexOf(id) == -1) {
            data.push(id)
        }
        else {
            data.splice(data.indexOf(id), 1)
        }
        setListSelected(data)
    }

    return (
        <div className="w-[50%] md:w-[20%] p-2">
            <div onClick={() => handelCheckItem(item.id)} className="w-full min-h-[45px] cursor-pointer text-[12px] px-2 flex items-center bg-[#f9f9f9] shadow rounded-lg">
                {/* @ts-ignore */}
                <div className={`w-[20px] h-[20px]  rounded ml-2 flex items-center justify-center ${listSelected.indexOf(item.id) == -1 ? 'border' : 'bg-dayan-orange-50'} `} >
                    {/* @ts-ignore */}
                    {listSelected.indexOf(item.id) != -1 &&
                        <svg x="0px" y="0px" viewBox={'0 0 405.272 405.272'} className={`fill-white h-[10px] `}>

                            <use xlinkHref="/assetes/svg/check.svg#check" />
                        </svg>
                    }
                </div>
                <span>{item[name]}</span>
            </div>
        </div>
    )
}


export const AccessLevelSelectAll = ({ listSelected, setListSelected, allItems }: SelectAllInputProps) => {
    const [isSelect, setIsSelect] = useState<boolean>(false)

    const handelSelectAll = () => {
        let data = [];
        if (listSelected.length != allItems?.length) {
            for (let i of allItems) {
                data.push(i.id)
            }
            setIsSelect(true)
            setListSelected(data)
            return
        }
        else {
            setIsSelect(false)
            setListSelected([])
            return
        }
    }

    return (
        <div className="w-[50%] md:w-[20%] p-2">
            <div onClick={handelSelectAll} className="w-full min-h-[45px] cursor-pointer text-[12px] px-2 flex items-center bg-[#f9f9f9] shadow rounded-lg">
                <div className={`w-[20px] h-[20px]  rounded ml-2 flex items-center justify-center ${isSelect ? 'bg-dayan-orange-50' : 'border'} `} >
                    {isSelect &&
                        <svg x="0px" y="0px" viewBox={'0 0 405.272 405.272'} className={`fill-white h-[10px] `}>
                            <use xlinkHref="/assetes/svg/check.svg#check" />
                        </svg>
                    }
                </div>
                <span>انتخاب همه</span>
            </div>
        </div>
    )
}


export type SelectAllInputProps = {
    listSelected: [] | any[],
    setListSelected: (list: any) => void,
    allItems: [] | any[]
}

export type InputProps = {
    listSelected: [] | any[],
    setListSelected: (list: any) => void,
    item: any,
    name: string,
}

